import { get } from 'lodash/fp';

export const getIdToken = () => state => get('user.idToken')(state);
export const getAccessToken = () => state => get('user.accessToken')(state);
export const getRefreshToken = () => state => get('user.refreshToken')(state);

export const getIsAuthenticated = () => state => get('user.isAuthenticated')(state);
